import { createContext, useContext, useMemo } from 'react';
import { AnomalyDocument } from '../components/document/AnomalyDocumentCard';

interface AnomalyDocumentContext {
  anomalyDocument: AnomalyDocument;
}

const Context = createContext<AnomalyDocumentContext | null>(null);

export interface AnomalyDocumentProviderProps {
  children?: React.ReactNode;
  anomalyDocument: AnomalyDocument;
}

export const AnomalyDocumentProvider = (props: AnomalyDocumentProviderProps) => {
  const { anomalyDocument, children } = props;

  const ctx = useMemo(
    () => ({
      anomalyDocument,
    }),
    [anomalyDocument],
  );

  return <Context.Provider value={ctx}>{children}</Context.Provider>;
};

export const useAnomalyDocumentContext = () => {
  const ctx = useContext(Context);

  if (!ctx) {
    throw new Error('Anomaly Document Context not found');
  }

  return ctx;
};
